/** Product module upsell strings (RequireModule / UpgradeCta) — EN / UK. */

const EN = {
  moduleNotConnected: 'This module is not enabled for the project.',
  moduleDisabledContactProvider:
    'Please contact your platform provider to enable this module.',
  wantConnect: 'I want to connect',
  contactLabel: 'Contact support:',
  emailCopied: 'Email copied to clipboard',
  modules: {
    telegram: {
      name: 'Telegram notifications',
      description: 'Project bot settings, event notifications and test messages.',
    },
    telegram_advanced: {
      name: 'Advanced TG',
      description:
        'Upgrade for the Telegram addon: replace default alert texts with your own templates, live tag tokens, and preview.',
    },
    trends: {
      name: 'Trends',
      description: 'Trend storage, collection settings and tag charts.',
    },
    svg_hmi: {
      name: 'SVG HMI',
      description: 'SVG runtime configs, tag bindings and card detail layouts.',
    },
    project_tags: {
      name: 'Project-local tags',
      description: 'Tags scoped to the tenant (ProjectTagDefinition / values), not UID catalog.',
    },
    project_alarm_rules: {
      name: 'Project alarm rules',
      description: 'Configurable alarm rules at project level. Acknowledgement is included in core.',
    },
    debug_tools: {
      name: 'Debug tools',
      description: 'Packet inspection and diagnostics for support.',
    },
    maps: {
      name: 'Maps UI',
      description: 'MapLibre station map on the groups page using card coordinates.',
    },
  },
};

const UK = {
  moduleNotConnected: 'Цей модуль не підключено до проєкту.',
  moduleDisabledContactProvider:
    'Зверніться до постачальника платформи, щоб увімкнути цей модуль.',
  wantConnect: 'Хочу підключити',
  contactLabel: 'Звʼяжіться з підтримкою:',
  emailCopied: 'Email скопійовано в буфер обміну',
  modules: {
    telegram: {
      name: 'Telegram-сповіщення',
      description: 'Налаштування бота проєкту, сповіщення про події та тестові повідомлення.',
    },
    telegram_advanced: {
      name: 'Advanced TG',
      description:
        'Доповнення до модуля Telegram: власні тексти сповіщень замість стандартних, з токенами тегів і превʼю.',
    },
    trends: {
      name: 'Тренди',
      description: 'Зберігання трендів, налаштування збору та графіки по тегах.',
    },
    svg_hmi: {
      name: 'SVG HMI',
      description: 'SVG-конфіги, привʼязка тегів і макети детальної картки.',
    },
    project_tags: {
      name: 'Локальні теги проєкту',
      description: 'Теги рівня tenant (ProjectTagDefinition / values), не UID-каталог.',
    },
    project_alarm_rules: {
      name: 'Правила тривог проєкту',
      description: 'Налаштовувані правила тривог на рівні проєкту. Підтвердження входить у core.',
    },
    debug_tools: {
      name: 'Інструменти діагностики',
      description: 'Перегляд пакетів і діагностика для підтримки.',
    },
    maps: {
      name: 'Карта станцій',
      description: 'MapLibre-карта на сторінці груп за координатами карток.',
    },
  },
};

export function getProjectModulesLocale(lang) {
  return lang === 'uk' ? UK : EN;
}
